import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Anchor, CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Invalid verification link.");
      return;
    }
    (async () => {
      try {
        const { data } = await api.get(`/auth/verify-email?token=${token}`);
        setStatus("success");
        setMessage(data.message);
      } catch (err) {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Verification failed.");
      }
    })();
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <Anchor className="h-7 w-7 text-primary" />
          <span className="font-bold text-xl text-[#0a1628]" style={{ fontFamily: 'Manrope' }}>CalmOceanPrep</span>
        </Link>
        <Card className="border" data-testid="verify-email-card">
          <CardContent className="p-6 text-center">
            {status === "loading" && (
              <div className="py-4">
                <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto mb-3" />
                <p className="text-sm text-muted-foreground">Verifying your email...</p>
              </div>
            )}
            {status === "success" && (
              <div className="py-4">
                <CheckCircle2 className="h-10 w-10 text-green-500 mx-auto mb-3" />
                <p className="font-medium mb-1">{message}</p>
                <Button className="mt-4" asChild data-testid="verify-login-btn">
                  <Link to="/login">Log In</Link>
                </Button>
              </div>
            )}
            {status === "error" && (
              <div className="py-4">
                <XCircle className="h-10 w-10 text-red-500 mx-auto mb-3" />
                <p className="font-medium text-red-600 mb-1">{message}</p>
                <Button variant="outline" className="mt-4" asChild>
                  <Link to="/signup">Try Again</Link>
                </Button>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
